module.exports = __webpack_public_path__ + "static/media/IconRewardsGreen.99b725ab.svg";